import classNames from 'classnames';

import { RequestStatus } from '../types';
import { CircularProgress } from '../CircularProgress';
import { Link } from '../Link';

/**
 * Свойства компонента {@link Chat}
 */
interface ChatProps {
  /**
   * Текущий статус чата.
   */
  status: RequestStatus;

  /**
   * Функция для загрузки чата WebIM.
   */
  loadWebim: () => void;

  /**
   * Имя аккаунта WebIM.
   */
  webimAccountName: string;
}

/**
 * Компонент, отображающий кнопку чата с различными состояниями (idle, loading, complete, failed).
 * Включает индикатор загрузки и может вызывать функцию загрузки чата WebIM при клике.
 *
 * @internal
 * @param status - Текущий статус чата.
 * @param loadWebim - Функция для загрузки чата WebIM.
 * @param webimAccountName - Имя аккаунта WebIM.
 * @returns Компонент Chat.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ChatProps}
 */
export const Chat = ({ status, loadWebim, webimAccountName }: ChatProps) => {
  const isLoading = status === 'loading';
  const isComplete = status === 'complete';

  return (
    <>
      {(isLoading || isComplete) && (
        <Link
          className={classNames(
            'webim_button',
            'hidden',
            'vkdoc_webim_loaded',
            'aqa_chat_link',
          )}
          onClick={() => {}}
        >
          <img
            alt="webim"
            src={`https://${webimAccountName}.webim.ru/button.php`}
          />
        </Link>
      )}

      <Link
        className={classNames(
          'webim_button',
          'webim_button_no_loaded',
          'aqa_chat_link',
          isLoading && 'webim_button_loading',
          isComplete && 'hidden',
        )}
        onClick={loadWebim}
      >
        {isLoading && <CircularProgress size={30} />}
      </Link>
    </>
  );
};
